import { render, staticRenderFns } from "./form-section-header.vue?vue&type=template&id=2d4aacfb"
import script from "./form-section-header.vue?vue&type=script&lang=js"
export * from "./form-section-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports